module.exports = __webpack_public_path__ + "static/media/anni_bottom.f298334e.png";